import clsxm from "@/lib/clsxm"

import Heading from "@/components/common/Heading/Heading"
import UnstyledLink from "@/components/common/Links/UnstyledLink"

export const ServicesHeading = () => {
  return (
    <div className={`flex flex-row items-center justify-center bg-mint`}>
      <UnstyledLink href={`/services`}>
        <Heading
          className={clsxm(
            `cursor-pointer p-5 text-center font-baskervilleHeadings text-4xl font-bold tracking-tight`
          )}
          headingLevel={`h2`}
        >
          Services
        </Heading>
      </UnstyledLink>
    </div>
  )
}
